import { Radio as MuiRadio, RadioProps as MuiRadioProps, useTheme } from '@mui/material';
import { RadioCheckedIcon, RadioUncheckedIcon } from 'design-system';
import { FC, useMemo } from 'react';

export type RadioProps = MuiRadioProps & {
  customColor?: string;
};

export const Radio: FC<RadioProps> = ({ customColor, ...props }) => {
  const theme = useTheme();

  const color = useMemo<string>(() => {
    if (customColor) {
      return customColor;
    }
    if (props.disabled) {
      return theme.palette.principal.grey70;
    }
    return theme.palette.brand.jungle;
  }, [theme, props.disabled, customColor]);

  return (
    <MuiRadio
      icon={<RadioUncheckedIcon />}
      checkedIcon={<RadioCheckedIcon sx={{ color }} />}
      {...props}
    />
  );
};
